import { useEffect, useState } from "react";
import Modal from "../../common/Modal";
import { Blog } from "../../../types/common.types";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import { AiOutlineCloseCircle } from "react-icons/ai";
import styled from "styled-components";
import format from "date-fns/format";
import { useGlobal } from "../../../context/global";

export default function ListBlogs() {
    const { setIsLoading } = useGlobal()
    const { listBlogsTourId, setListBlogsTourId, setEditBlog } = useAdmin()
    const [blogs, setBlogs] = useState<Blog[]>([]) 
    useEffect(() => {
        async function fetchBlogs() {
            if (!listBlogsTourId) return
            setIsLoading(true)
            try {
                const response = (await AdminService.listBlogsTour(listBlogsTourId)).data
                setBlogs(response)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        fetchBlogs()
    }, [])
    return (
        <Modal>
            <h1>Blogs</h1>
            <div className="close" title="close"
            onClick={() => setListBlogsTourId(undefined)}
            >
                <AiOutlineCloseCircle/>
            </div>
            {
                blogs.map(blog => (
                    <Card onClick={()=> setEditBlog(blog)} key={blog.id}>
                        <h3>{blog.title}</h3>
                        <p>{blog.overview}</p>
                        <p>{format(new Date(blog.created_at), 'dd/MM/yyyy')}</p>
                    </Card>
                ))
            }
        </Modal>
    )
}

const Card = styled.div`
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.2s ease;
    &:hover {
        transform: translateY(-4px);
    }
`